import { render, staticRenderFns } from "./addContactWay.vue?vue&type=template&id=c5fc55d2&"
import script from "./addContactWay.vue?vue&type=script&lang=js&"
export * from "./addContactWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5fc55d2')) {
      api.createRecord('c5fc55d2', component.options)
    } else {
      api.reload('c5fc55d2', component.options)
    }
    module.hot.accept("./addContactWay.vue?vue&type=template&id=c5fc55d2&", function () {
      api.rerender('c5fc55d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addContactWay.vue"
export default component.exports